import React, { useEffect, useState, useRef, useContext } from 'react';
import Controls_Map_Floors from '../InteractiveMap/Controls_Map_Floors';
import Controls_Map_Selector from '../InteractiveMap/Controls_Map_Selector';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Toggle from '../ERUMAUI/UI_Toggle';
import Render_MapEditor from './Render_MapEditor';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useMapEditor } from '../../Contexts/Context_MapEditor';

export default function Panel_MapEditor_Center() {
    // const { Account, Loading } = useAuth();
    
    
    const { Map_Composition, Refresh, Map_HighlightedMarker_Set, Selected_Building, Selected_Building_Set, Selected_Floor, Selected_Floor_Set, Transformer_Reference, Container_Reference } = useMapRenderer();
    const { Map_MovableMarkers_Set } = useMapEditor();
    const UI = useContext(Context_UI);
    useEffect(() => {
        const OnListSelect = ({ ID, State }) => {
            if (ID == "ME_Control_MovableMarkers") {
                if (State == "Inactive") {
                    Map_MovableMarkers_Set(false);
                } else {
                    Map_MovableMarkers_Set(true);
                }
            }
        }
        UI.on("Button_Toggled", OnListSelect);
        return () => {
            UI.off("Button_Toggled", OnListSelect);
        }
    }, []);


    return (
        <div className='ME_Container'>
            <TransformWrapper
                initialScale={1}
                minScale={0.5}
                maxScale={3}
                wheel={{ disabled: false }}
                doubleClick={{ disabled: false }}
                ref={Transformer_Reference}
            >
                {({ zoomIn, zoomOut }) => (
                    <>
                        <Controls_Map_Selector
                            Map_Composition={Map_Composition}
                            Building_Set={Selected_Building_Set}
                            Floor_Set={Selected_Floor_Set}
                            Selected_Building={Selected_Building}
                            Selected_Floor={Selected_Floor}
                            Absolute={true}
                            NoTime={true}
                        >
                            <UI_Toggle style={{ height: "42px" }} id="ME_Control_MovableMarkers" Text="Make markers movable" Type="Switch" Selected="false" />
                        </Controls_Map_Selector>
                        <Controls_Map_Floors
                            Map_Composition={Map_Composition}
                            Selected_Building={Selected_Building}
                            Selected_Floor={Selected_Floor}
                            Floor_Set={Selected_Floor_Set}
                        />

                        {/* <Controls_Map_Zoom
                            Zoom_In={zoomIn}
                            Zoom_Out={zoomOut}
                        /> */}
                        <TransformComponent>
                            <div ref={Container_Reference} className='Renderer_Map'>
                                <Render_MapEditor
                                    Map_Composition={Map_Composition}
                                    Selected_Building={Selected_Building}
                                    Selected_Floor={Selected_Floor}
                                    Floor_Set={Selected_Floor_Set}
                                    Container_Reference={Container_Reference}
                                />
                            </div>
                        </TransformComponent>
                    </>

                )}
            </TransformWrapper>
        </div>
    );

}


